var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"vpd-content",attrs:{"fluid":""}},[_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"1000"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('vpd-change-password-panel',{ref:"changePasswordPanel",on:{"submit":_vm.submitPasswordChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }